import styled from 'styled-components';

const BoxContainer = styled.div`
  /* position: relative; */
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 24px;
  background: #ebf1fc;
  padding: 4px 0 4px 16px;  
  color: #5e5e5e;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;

  .box-type {
    color: #000;
    text-align: center;
    font-family: Roboto;
    font-size: 10px;
    font-weight: 400;
    margin: 1px 10px 0px 0px;
    text-transform: uppercase;    
  }

  .box-content {
    color: #000;
    text-align: center;
    font-family: Roboto;
    font-size: 10px;
    font-weight: 400;
    margin: 0px 10px 0px 0px;

    span {
      font-size: 12px;
      font-weight: 600;
    }
  }
`;

export const BoxInfo = ({
  dataBox = {
    width: '',
    title: '',
    content: '',
  },
}) => {
  return (
    <BoxContainer width={dataBox.width} text={dataBox.title}>
      <div className="box-type">
        {dataBox.title}
      </div>
      {dataBox.content.map((arrInfo, infoIndex) => (
        <div key={infoIndex} className="box-content">
          {arrInfo[0]}: <span>{arrInfo[1]}</span>
        </div>
      ))}      
    </BoxContainer>
  );
};
